import { QUERY_PARAMS, STORAGE_KEYS } from "../config";
import { pushState } from "./route-util";
import { takeId, User, UserRewardKind } from "shared";

export interface ReferralReward {
	reward: UserRewardKind;
	count: number;

	// Only show if the user was referred by a friend
	isFriendReferral?: boolean;
}

export const REFERRAL_REWARDS: ReferralReward[] = [
	{
		reward: "palette-friends",
		count: 0,
		isFriendReferral: true
	},
	{
		reward: "palette-mixtape",
		count: 1
	},
	{
		reward: "palette-seaside",
		count: 2
	},
	{
		reward: "palette-sundown",
		count: 5
	},
	{
		reward: "palette-midnight",
		count: 10
	},
	{
		reward: "palette-dusk",
		count: 15
	},
	{
		reward: "palette-tron",
		count: 20
	},
	{
		reward: "palette-heirloom",
		count: 30
	},
	{
		reward: "palette-synthwave",
		count: 40
	},
	{
		reward: "palette-tropical",
		count: 50
	},
	{
		reward: "palette-bloom",
		count: 75
	},
	{
		reward: "palette-colorwheel",
		count: 100
	}
];


export function getFriendReferralLink(user: User) {
	return `${window.location.origin}?${QUERY_PARAMS.ref}=${takeId(user)}`;
}

/**
 * Saves the referral code to local storage if there is one.
 */
export async function saveFriendReferralId() {
	const params = new URLSearchParams(location.search);
	const ref = params.get(QUERY_PARAMS.ref);
	if (ref?.length) {
		localStorage.setItem(STORAGE_KEYS.friendReferralId, ref);

		// Remove the referral code from the URL
		params.delete(QUERY_PARAMS.ref);
		pushState(`${location.pathname}${params.toString() ? `?${params.toString()}` : ""}`, {
			replace: true,
			silent: true
		});
	}
}

/**
 * Consumes the referral code from local storage if there is one.
 */
export function consumeFriendReferralId(): string | undefined {
	const ref = localStorage.getItem(STORAGE_KEYS.friendReferralId);
	if (ref?.length) {
		localStorage.removeItem(STORAGE_KEYS.friendReferralId);
		return ref;
	}

	return undefined;
}
